<!--
  -    Copyright (c) 2018-2025, lengleng All rights reserved.
  -
  - Redistribution and use in source and binary forms, with or without
  - modification, are permitted provided that the following conditions are met:
  -
  - Redistributions of source code must retain the above copyright notice,
  - this list of conditions and the following disclaimer.
  - Redistributions in binary form must reproduce the above copyright
  - notice, this list of conditions and the following disclaimer in the
  - documentation and/or other materials provided with the distribution.
  - Neither the name of the pig4cloud.com developer nor the names of its
  - contributors may be used to endorse or promote products derived from
  - this software without specific prior written permission.
  - Author: lengleng (wangiegie@gmail.com)
  -->
<template>
	<div class="execution">
		<basic-container>
			<avue-crud
				ref="crud"
				v-model="form"
				:before-open="onHandleBeforeOpen"
				:data="tableData"
				:option="tableOption"
				:page.sync="page"
				:table-loading="tableLoading"
				@on-load="getList"
				@search-change="searchChange"
				@refresh-change="refreshChange"
				@size-change="sizeChange"
				@current-change="currentChange"
				@row-update="handleUpdate"
				@row-save="handleSave"
				@row-del="rowDel">
				<template slot="menuLeft">
					<el-button icon="el-icon-edit" type="primary" @click="openImport">批量切换产品id</el-button>
				</template>

				<template slot="productPlanRelationList" slot-scope="{row}">
					<div v-for="(item, index) in row.productPlanRelationList" :key="index">
						方案名称：{{ item.planName }} 方案Id：{{ item.planId }}
					</div>
				</template>
				<template slot="productPlanRelationListForm" slot-scope="{row}">
					<div v-if="form.productPlanRelationList && form.productPlanRelationList.length > 0">
						<el-row v-for="(item, index) in form.productPlanRelationList" :key="index">
							<el-col :span="10">
								<el-input v-model="item.planId" placeholder="请输入方案id"></el-input>
							</el-col>
							<el-col :span="10">
								<el-input v-model="item.planName" placeholder="请输入方案名称"></el-input>
							</el-col>
							<el-col :span="4">
								<el-button
									circle
									icon="el-icon-plus"
									style="margin-left: 5px"
									type="primary"
									@click="
										form.productPlanRelationList
											? form.productPlanRelationList.push({})
											: (form.productPlanRelationList = [{}])
									"></el-button>
								<el-button
									circle
									icon="el-icon-minus"
									style="margin-left: 5px"
									type="danger"
									@click="form.productPlanRelationList.splice(index, 1)"></el-button>
							</el-col>
						</el-row>
					</div>
					<div v-else>
						<el-button
							circle
							icon="el-icon-plus"
							type="primary"
							@click="
								form.productPlanRelationList
									? form.productPlanRelationList.push({})
									: (form.productPlanRelationList = [{}])
							"></el-button>
					</div>
				</template>
			</avue-crud>

			<el-dialog :visible.sync="importModal" append-to-body title="批量切换产品id" width="35%">
				<div class="import-main">
					<div style="display: flex; flex-direction: column; align-items: center">
						<el-upload
							:before-upload="beforeUpload"
							:file-list="importFileList"
							:limit="1"
							:on-remove="handleRemove"
							accept=".xlsx"
							action=""
							drag
							multiple>
							<i class="el-icon-upload"></i>
							<div class="upload-import-text-main">
								<span>点击上传或拖拽文件到这里进行上传</span>
							</div>
						</el-upload>
					</div>
				</div>

				<div slot="footer" class="dialog-footer">
					<el-button @click="downImportExcel">下载模板</el-button>
					<el-button @click="importModal = false">取消</el-button>
					<el-button :disabled="importFileList.length == 0" type="primary" @click="confirmBatchExport">导入</el-button>
				</div>
			</el-dialog>
		</basic-container>
	</div>
</template>

<script>
import {addObj, delObj, fetchList, putObj} from '@/api/product/productManage'
import {productIdsImport} from '@/api/team/place'
import {tableOption} from '@/const/crud/product/productManage'
import FileSaver from 'file-saver'

export default {
	name: 'ProductManage',
	data() {
		return {
			importModal: false,
			importFileList: [],
			searchForm: {},
			form: {},
			tableData: [],
			page: {
				total: 0, // 总页数
				currentPage: 1, // 当前页数
				pageSize: 10, // 每页显示多少条
			},
			tableLoading: false,
			tableOption: tableOption,
		}
	},
	created() {
		// this.tableOption.column.forEach((itemData) => {
		//   if (itemData.prop === 'insureType') {
		//     itemData.dicData = getChannelProductList()[0]
		//   }
		// })
	},
	computed: {},
	methods: {
		//删除文件
		handleRemove(file, fileList) {
			if (file && file.status == 'success') {
				this.importFileList = []
			}
		},
		beforeUpload(file) {
			this.importFileList = [file]
			return false
		},
		//数据导入
		async openImport() {
			this.importFileList = []
			// this.importStep = 1

			//查询费率规则字典项目数据
			this.importModal = true
		},
		confirmBatchExport() {
			const formData = new FormData()
			this.importFileList.forEach((file) => {
				formData.append('file', file)
			})
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)',
			})
			productIdsImport(formData)
				.then(({data}) => {
					this.$message.success('导入成功!')
					this.importModal = false
					loading.close()
				})
				.catch((e) => {
					loading.close()
					this.importLoading = false
				})
		},
		//下载导入模板
		downImportExcel() {
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)',
			})
			var xhr = new XMLHttpRequest()
			xhr.open('GET', '/download/批量切换产品id.xlsx')
			xhr.responseType = 'blob'
			xhr.onload = () => {
				FileSaver.saveAs(xhr.response, '批量切换产品id导入模板')
				loading.close()
				this.$message.success('下载模板成功！')
			}
			xhr.send()
		},
		getList(page, params) {
			this.tableLoading = true
			fetchList(
				Object.assign(
					{
						current: page.currentPage,
						size: page.pageSize,
					},
					params,
					this.searchForm,
				),
			)
				.then((response) => {
					this.tableData = response.data.data.records
					this.page.total = response.data.data.total
					this.tableLoading = false
				})
				.catch(() => {
					this.tableLoading = false
				})
		},
		//打开修改
		onHandleBeforeOpen(done, type) {
			if (['view', 'edit', 'add'].includes(type)) {
				// 查看和编辑逻辑
				let data = {...this.form}
				if (data.price) {
					data.price = data.price / 100
				}
				if (data.groupLogo) {
					data.groupLogoUrl = data.groupLogo
				}
				if (data.intros) {
					data.introsList = JSON.parse(data.intros)
				}
				this.form = data
			}
			done()
		},
		rowDel: function (row, index) {
			this.$confirm('是否确认删除ID为' + row.id, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(function () {
					return delObj(row.id)
				})
				.then((data) => {
					this.$message.success('删除成功')
					this.getList(this.page)
				})
		},
		handleUpdate: function (row, index, done, loading) {
			let data = {...row}
			if (data.price) {
				data.price = row.price * 100
			}
			if (data.groupLogoUrl) {
				data.groupLogo = data.groupLogoUrl
			}
			if (data.introsList) {
				data.intros = JSON.stringify(data.introsList)
			}
			//校验 data.productPlanRelationList 方案 planId 和 planName 必填
			if (data.productPlanRelationList) {
				let flag = true
				data.productPlanRelationList.forEach((item) => {
					if (!item.planId || !item.planName) {
						flag = false
					}
				})
				if (!flag) {
					this.$message.error('方案id和方案名称必填')
					loading()
					return
				}
			}
			putObj(data)
				.then((data) => {
					this.$message.success('修改成功')
					done()
					this.getList(this.page)
				})
				.catch(() => {
					loading()
				})
		},
		handleSave: function (row, done, loading) {
			let data = {...row}
			if (data.price) {
				data.price = row.price * 100
			}
			if (data.groupLogoUrl) {
				data.groupLogo = data.groupLogoUrl
			}
			if (data.introsList) {
				data.intros = JSON.stringify(data.introsList)
			}
			//校验 data.plan 方案 id 和 name 必填
			if (data.productPlanRelationList) {
				let flag = true
				data.productPlanRelationList.forEach((item) => {
					if (!item.planId || !item.planName) {
						flag = false
					}
				})
				if (!flag) {
					this.$message.error('方案id和方案名称必填')
					loading()
					return
				}
			}
			addObj(data)
				.then((data) => {
					this.$message.success('添加成功')
					done()
					this.getList(this.page)
				})
				.catch(() => {
					loading()
				})
		},
		searchChange(form, done) {
			this.searchForm = form
			this.page.currentPage = 1
			this.getList(this.page, form)
			done()
		},
		sizeChange(pageSize) {
			this.page.pageSize = pageSize
		},
		currentChange(current) {
			this.page.currentPage = current
		},
		refreshChange() {
			this.getList(this.page)
		},
	},
}
</script>

<style lang="scss" scoped></style>
